// extracted by mini-css-extract-plugin
export var blue = "_2w-f";
export var brand = "_2w-b";
export var darkGrey = "_2w-e";
export var disabled = "_2w-4";
export var disabledSubtle = "_2w-5";
export var error = "_2w-6";
export var green = "_2w-g";
export var grey = "_2w-d";
export var icon = "_2w-0";
export var inherit = "_2w-a";
export var lightGrey = "_2w-c";
export var orange = "_2w-i";
export var pink = "_2w-k";
export var primary = "_2w-1";
export var purple = "_2w-l";
export var red = "_2w-j";
export var secondary = "_2w-2";
export var success = "_2w-9";
export var tertiary = "_2w-3";
export var warning = "_2w-7";
export var warningSecondary = "_2w-8";
export var white = "_2w-m";
export var yellow = "_2w-h";